module.exports = __webpack_public_path__ + "static/media/PlaceholderBG.5268592e.jpg";